
import { Options, Vue } from 'vue-class-component';
import AppTile from './AppTile.vue';
import api from '@/shared/api';
import getAppDefinitions, { AppDefinitions } from '@/shared/apps';
import session from '@/shared/session';

@Options({
    components: {
        AppTile,
    },
})
export default class AppOverview extends Vue {
    protected billingType = process.env.VUE_APP_RAFFISH_BILLING_TYPE || '';
    protected installedApps = [];
    protected availableApps: AppDefinitions = {};

    protected ready = false;

    async created() {
        this.availableApps = await getAppDefinitions();
        const apps = await api.getInstalledActiveApps();
        console.log('installedApps', apps);
        this.installedApps = apps;

        this.ready = true;
    }

    protected removeModal = false;
    protected deletedIntendedAppId = '';

    protected getInstalledAppRouteName(app: any) {
        const appDef = this.availableApps[app.app_name];
        if (appDef && appDef.config && appDef.config.integrationType === 'external-iframe') {
            return 'app-external-launch';
        }
        return app.authenticated ? 'app-settings' : 'app-sprinklr-authorize';
    }

    async removeApp(app: any) {
      this.removeModal = true;
      this.deletedIntendedAppId = app.appId;
      console.log(this.deletedIntendedAppId);

    }
    async removeAppConfirm() {
      const appId = parseInt(this.deletedIntendedAppId);
      await api.removeApp(appId);

      this.$router.push({ name: 'apps-store'});
    }

    get isBusinessUnitBilling(): boolean {
        return this.billingType === 'business-unit';
    }

    get currentBusinessUnit() {
        const businessUnits = session.getBusinessUnits();
        const currentBusinessUnitId = session.getCurrentBusinessUnit();
        return businessUnits.find((bu) => bu.id === currentBusinessUnitId);
    }

    get showNoSubscriptionOverlay(): boolean {
        if (!this.isBusinessUnitBilling) {
            return false;
        }

        const subscription = this.currentBusinessUnit?.subscription;
        return !(subscription === 'trial' || subscription === 'paid');
    }

    getSmallDesc(app: any) {
        let desc = ['Authorized by ' + app.user];

        if (this.isBusinessUnitBilling) {
            return desc;
        }

        if (app.automatic_renewal) {
            desc.push('Automatically renews on ' + new Date(app.end).toLocaleDateString());
        } else if (app.end == null) {
            desc.push('Your Subscription doesnt expire');
        } else {
            desc.push('Subscription expires on ' + new Date(app.end).toLocaleDateString());
        }

        return desc;
    }
}
